import React, { useEffect } from "react";
import Auth from "./Auth";
import { Navigate, Outlet, useNavigate } from 'react-router-dom';

const ProtectedRoutes = ({ component: Component, ...rest }) => {


  const navigate = useNavigate();

  useEffect(() => {
    const tokeninfo1 = localStorage.getItem("tokeninfo");
    const tokeninfo = tokeninfo1 ? JSON.parse(tokeninfo1) : null;
    if (tokeninfo) {
      Auth.signin(() => {
        navigate('/projects')
      })
    } else {
      Auth.signout(() => {
        navigate('/login')
      })
    }

  }, [])


  return (
    Auth.getAuth() ? (
      <Outlet />
    ) : (
      <Navigate to="/login" />
    )
  );
};

export default ProtectedRoutes;
